import * as React from "react";

function SvgPrevious(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
      <path d="M21 8l-10 8 10 8V8z" fill="#fff" />
    </svg>
  );
}

export default SvgPrevious;
